// Older product descriptions embed YouTube with the Flash-era player (youtube.com/v/ID),
// which no browser plays anymore. Swap each one for the poster-first player (no YouTube chrome until played).
(function () {
  document.querySelectorAll('embed[src*="youtube.com/v/"]').forEach(function (embed) {
    var match = embed.getAttribute('src').match(/\/v\/([\w-]{11})/);
    if (!match) return;

    // Same poster-first markup as snippets/rc-poster-video.liquid (handler in rc-poster-video-assets).
    // Older uploads have no maxresdefault thumbnail, so use hqdefault.
    var wrapper = document.createElement('div');
    wrapper.className = 'rc-video';
    wrapper.setAttribute('data-rc-video', match[1]);
    wrapper.innerHTML =
      '<button type="button" class="rc-video__poster" aria-label="Play video">' +
      '<img src="https://i.ytimg.com/vi/' + match[1] + '/hqdefault.jpg" alt="" width="480" height="360" loading="lazy">' +
      '<span class="rc-video__play" aria-hidden="true"><svg viewBox="0 0 68 68" width="68" height="68"><circle cx="34" cy="34" r="34" fill="#D92126"/><path d="M27 21 49 34 27 47z" fill="#fff"/></svg></span>' +
      '</button>';

    (embed.closest('object') || embed).replaceWith(wrapper);
  });

  // "Watch the demo video" link at the top of product pages targets the first video
  var firstVideo = document.querySelector('.rc-video');
  if (firstVideo) firstVideo.id = 'demo-video';
})();
